/* Nibec · cotización fluida del encabezado (17-oct-2026, Bigbuda)
   Escritorio (≥990 px, mouse): el panel se abre al pasar el cursor (80 ms de intención) y al enfocar con el teclado;
   se cierra 200 ms después de salir. Un clic abre y FIJA el panel; otro clic, Escape o un clic fuera lo cierran.
   Celular y tablet (<990 px): el botón abre un panel inferior con las mismas opciones; se cierra con la X, tocando
   fuera, deslizando hacia abajo o con Escape.
   El panel muestra la lista de cotización (localStorage nibecCotizacion, la misma de assets/nibec-cotizacion.js) y
   arma el WhatsApp con sus funciones (window.NibecCotizacion).
   Medición: nibec_hdr_cotizar_abrir (metodo hover|clic|foco|toque, UNA vez por apertura del panel: el primer método que
   lo abre; hover, clic y foco sobre el panel ya abierto no vuelven a contar, 18-oct T-0879b; el hover cuenta solo si
   el panel queda abierto 400 ms) y nibec_hdr_cotizar_formulario, por Shopify.analytics y dataLayer. El WhatsApp se
   mide como siempre (nibec_whatsapp_click, ubicacion cabecera).
   Se apaga en Header Nibec › Botón de cotización › «Cotización fluida…» (entonces este archivo no se carga). */
(function () {
  'use strict';
  var root = document.querySelector('[data-hc]');
  if (!root || root.__hc) return;
  root.__hc = true;
  root.classList.add('nibec-hc--js');

  var btn = root.querySelector('[data-hc-btn]');
  var panel = root.querySelector('[data-hc-panel]');
  var cuerpo = panel && panel.querySelector('[data-hc-cuerpo]');
  if (!btn || !panel || !cuerpo) return;

  // T-0953 (20-oct-2026): con «Nibec · Cotización única» (layout/theme.liquid pone data-cotiza-unica en el script de la lista)
  // el botón de la cabecera no abre panel: lleva directo a la página única de cotización, en celular y en computador.
  // Se mide como cotiza_cta_clic con ubicacion «cabecera» (snippets/nibec-cotiza-barra.liquid). Apagado = el panel de siempre.
  var unica = document.querySelector('script[data-cotiza-unica]');
  if (unica) {
    var destino = (unica.getAttribute('data-cotiza-unica') || '/pages/contacto') + '?desde=cabecera';
    root.classList.add('nibec-hc--directo');
    btn.setAttribute('data-cotiza-cta', 'cabecera');
    btn.removeAttribute('aria-expanded'); btn.removeAttribute('aria-controls'); btn.removeAttribute('aria-haspopup');
    panel.hidden = true;
    btn.setAttribute('role', 'link');
    var caret = btn.querySelector('.nibec-header__cta-caret'); if (caret) caret.style.display = 'none';
    btn.addEventListener('click', function (e) { e.preventDefault(); window.location.href = destino; });
    // El contador de la lista («Agregar a mi cotización») sigue en el botón.
    var contar = function () {
      var l = []; try { l = JSON.parse(localStorage.getItem('nibecCotizacion') || '[]'); } catch (e) {}
      var n = Array.isArray(l) ? l.length : 0, b = btn.querySelector('[data-hc-n]'), t = btn.querySelector('[data-hc-n-txt]');
      if (b) { b.hidden = !n; if (n && b.textContent !== String(n)) { b.textContent = n; b.classList.remove('nq-pop'); void b.offsetWidth; b.classList.add('nq-pop'); } }
      if (t) t.textContent = n ? ', ' + n + (n === 1 ? ' producto' : ' productos') + ' en tu cotización' : '';
    };
    document.addEventListener('nibec:lista', contar); window.addEventListener('storage', contar); contar();
    return;
  }

  var mm = function (q) { return window.matchMedia ? window.matchMedia(q) : { matches: false }; };
  var mqEsc = mm('(min-width: 990px)');
  var mqCel = mm('(max-width: 749px)');
  var mqReducir = mm('(prefers-reduced-motion: reduce)');
  var WA_LIQUID = (cuerpo.querySelector('[data-hc-wa]') || {}).href || '';

  var abierto = false, fijo = false, porFoco = false, volviendo = false;
  var tAbrir, tCerrar, tVisto, contado = false;
  var hoja = null, sheet = null, cuerpo2 = null, ultimoN = null;

  function lista() {
    var api = window.NibecCotizacion;
    if (api && api.load) return api.load();
    try { var a = JSON.parse(localStorage.getItem('nibecCotizacion') || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; }
  }
  function plural(n, a, b) { return n + ' ' + (n === 1 ? a : b); }
  function dispositivo() { return mqEsc.matches ? 'computador' : mqCel.matches ? 'celular' : 'tablet'; }
  function track(nombre, d) {
    d.dispositivo = dispositivo();
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(nombre, d); } catch (e) {}
    try { var o = { event: nombre }; for (var k in d) o[k] = d[k]; (window.dataLayer = window.dataLayer || []).push(o); } catch (e) {}
  }
  // T-0879b (18-oct-2026): antes había un tope «por método», así que una sola visita al panel empujaba 2 o 3 eventos
  // (hover al abrir, clic al fijarlo y foco al elegir una opción con el panel ya abierto; medido en nibec.cl). Ahora
  // cuenta una vez por apertura: `contado` se apaga al cerrar el panel (cerrar / cerrarHoja).
  function medirAbrir(metodo) {
    if (contado) return;
    contado = true;
    track('nibec_hdr_cotizar_abrir', { metodo: metodo, items: lista().length });
  }
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }

  function waHref(l) {
    var api = window.NibecCotizacion;
    if (!api || !api.waUrl) return WA_LIQUID;
    if (l.length || api.mensajeUnico) return api.waUrl(l); // con «Mensaje único de WhatsApp» (T-0954) el enlace lleva siempre el saludo
    var ctx = '';
    try { ctx = api.contexto ? api.contexto() : ''; } catch (e) {}
    return 'https://wa.me/' + api.numero + '?text=' + encodeURIComponent(ctx || 'Hola Nibec, necesito cotizar productos.');
  }

  // Lista (máx. 3 filas) o estado vacío, y el enlace de WhatsApp con la lista. Se pinta en el panel y en el panel inferior.
  function pintarCuerpo(c, l) {
    var box = c.querySelector('[data-hc-lista]'), vacio = c.querySelector('[data-hc-vacio]'), wa = c.querySelector('[data-hc-wa]');
    if (wa) wa.href = waHref(l);
    if (!box) return;
    box.textContent = '';
    box.hidden = !l.length;
    if (vacio) vacio.hidden = !!l.length;
    if (!l.length) return;
    var u = 0; l.forEach(function (i) { u += i.q; });
    var t = el('p', 'nibec-hc__titulo', 'Tu cotización');
    t.appendChild(el('small', '', plural(l.length, 'producto', 'productos') + ', ' + plural(u, 'unidad', 'unidades')));
    box.appendChild(t);
    var ul = el('ul', 'nibec-hc__items');
    l.slice(0, 3).forEach(function (i) {
      var li = el('li', 'nibec-hc__item'), f = el('span', 'nibec-hc__foto');
      if (i.i && /^https:\/\//.test(i.i)) { var im = el('img'); im.src = i.i; im.alt = ''; im.width = 40; im.height = 40; im.loading = 'lazy'; f.appendChild(im); }
      li.appendChild(f);
      var a = el('a', 'nibec-hc__nombre', i.t); a.href = /^\/[^\/]/.test(i.u || '') ? i.u : '/pages/contacto'; li.appendChild(a);
      var q = el('span', 'nibec-hc__cant', '× ' + i.q); q.setAttribute('aria-label', plural(i.q, 'unidad', 'unidades')); li.appendChild(q);
      ul.appendChild(li);
    });
    box.appendChild(ul);
    var mas = el('p', 'nibec-hc__mas');
    mas.appendChild(el('span', '', l.length > 3 ? 'y ' + plural(l.length - 3, 'producto', 'productos') + ' más' : ''));
    var ver = el('a', '', 'Ver o editar mi lista'); ver.href = '/pages/contacto';
    mas.appendChild(ver);
    box.appendChild(mas);
  }

  function pintarBoton(l) {
    var n = l.length, b = btn.querySelector('[data-hc-n]'), s = btn.querySelector('[data-hc-n-txt]');
    if (b) {
      b.hidden = !n;
      if (n && String(n) !== b.textContent) {
        b.textContent = n;
        if (ultimoN !== null && !mqReducir.matches) { b.classList.remove('nq-pop'); void b.offsetWidth; b.classList.add('nq-pop'); }
      }
    }
    if (s) s.textContent = n ? ', ' + plural(n, 'producto', 'productos') + ' en tu lista' : '';
    ultimoN = n;
  }

  function pintar() {
    var l = lista();
    pintarBoton(l);
    pintarCuerpo(cuerpo, l);
    if (cuerpo2) {
      pintarCuerpo(cuerpo2, l);
      var sub = sheet.querySelector('[data-hc-sub]');
      if (sub) { var u = 0; l.forEach(function (i) { u += i.q; }); sub.textContent = l.length ? plural(l.length, 'producto', 'productos') + ', ' + plural(u, 'unidad', 'unidades') : ''; sub.hidden = !l.length; }
    }
  }

  // ── Escritorio: panel bajo el botón ──────────────────────────────────────────────
  function abrir(metodo) {
    clearTimeout(tCerrar); clearTimeout(tAbrir);
    if (!abierto) {
      abierto = true;
      btn.setAttribute('aria-controls', 'nibec-hc-panel');
      pintar();
      root.classList.add('is-abierto');
      btn.setAttribute('aria-expanded', 'true');
    }
    if (metodo === 'hover') {
      clearTimeout(tVisto);
      tVisto = setTimeout(function () { if (abierto) medirAbrir('hover'); }, 400);
    } else medirAbrir(metodo);
  }
  function cerrar() {
    clearTimeout(tAbrir); clearTimeout(tCerrar); clearTimeout(tVisto);
    fijo = false; porFoco = false;
    if (!abierto) return;
    abierto = false; contado = false;
    root.classList.remove('is-abierto');
    btn.setAttribute('aria-expanded', 'false');
  }
  function esMouse(e) { return e.pointerType === 'mouse' && mqEsc.matches; }

  root.addEventListener('pointerenter', function (e) {
    if (!esMouse(e)) return;
    clearTimeout(tCerrar);
    if (!abierto) tAbrir = setTimeout(function () { abrir('hover'); }, 80);
  });
  root.addEventListener('pointerleave', function (e) {
    if (!esMouse(e)) return;
    clearTimeout(tAbrir);
    if (fijo || porFoco) return;
    tCerrar = setTimeout(cerrar, 200);
  });
  root.addEventListener('focusin', function (e) {
    if (!mqEsc.matches) return;
    if (volviendo) return; // el foco vuelve al botón tras Escape: no se reabre
    if (e.target === btn) { var fv = false; try { fv = btn.matches(':focus-visible'); } catch (err) { fv = true; } if (!fv) return; }
    porFoco = true;
    abrir('foco');
  });
  root.addEventListener('focusout', function (e) {
    if (!mqEsc.matches || root.contains(e.relatedTarget)) return;
    porFoco = false;
    if (e.relatedTarget || !root.matches(':hover')) cerrar();
  });
  document.addEventListener('pointerdown', function (e) {
    if (abierto && mqEsc.matches && !root.contains(e.target)) cerrar();
  }, true);

  btn.addEventListener('click', function (e) {
    e.preventDefault();
    if (!mqEsc.matches) { if (sheet && sheet.classList.contains('is-abierto')) cerrarHoja(); else abrirHoja(); return; }
    if (abierto && fijo) { cerrar(); return; }
    abrir('clic');
    fijo = true;
  });
  btn.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown' && mqEsc.matches) {
      e.preventDefault(); abrir('foco'); porFoco = true;
      var a = panel.querySelector('a'); if (a) a.focus();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (sheet && sheet.classList.contains('is-abierto')) { cerrarHoja(); return; }
    if (abierto) { var dentro = root.contains(document.activeElement); cerrar(); if (dentro) { volviendo = true; btn.focus(); volviendo = false; } }
  });

  // ── Celular y tablet: panel inferior ─────────────────────────────────────────────
  function crearHoja() {
    if (sheet) return;
    sheet = el('div', 'nibec-hc-sheet');
    sheet.hidden = true;
    var fondo = el('div', 'nibec-hc-sheet__fondo'); fondo.setAttribute('data-hc-cerrar', '');
    hoja = el('div', 'nibec-hc-sheet__hoja');
    hoja.id = 'nibec-hc-hoja'; hoja.setAttribute('role', 'dialog'); hoja.setAttribute('aria-modal', 'true'); hoja.setAttribute('aria-labelledby', 'nibec-hc-sheet-t'); hoja.tabIndex = -1;
    var asa = el('div', 'nibec-hc-sheet__asa'); asa.setAttribute('aria-hidden', 'true');
    var cab = el('div', 'nibec-hc-sheet__cab'), tt = el('div');
    var t = el('p', 'nibec-hc-sheet__t', 'Tu cotización'); t.id = 'nibec-hc-sheet-t';
    var sub = el('p', 'nibec-hc-sheet__sub'); sub.setAttribute('data-hc-sub', ''); sub.hidden = true;
    tt.appendChild(t); tt.appendChild(sub);
    var x = el('button', 'nibec-hc-sheet__x'); x.type = 'button'; x.setAttribute('aria-label', 'Cerrar'); x.setAttribute('data-hc-cerrar', '');
    x.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    cab.appendChild(tt); cab.appendChild(x);
    cuerpo2 = cuerpo.cloneNode(true);
    cuerpo2.removeAttribute('id');
    hoja.appendChild(asa); hoja.appendChild(cab); hoja.appendChild(cuerpo2);
    sheet.appendChild(fondo); sheet.appendChild(hoja);
    document.body.appendChild(sheet);
    sheet.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-hc-cerrar]')) cerrarHoja();
    });
    sheet.addEventListener('click', function (e) {
      var f = e.target.closest && e.target.closest('[data-hc-form]');
      if (f) track('nibec_hdr_cotizar_formulario', { items: lista().length });
    });
    // Foco atrapado dentro del panel mientras está abierto.
    hoja.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = hoja.querySelectorAll('a[href], button:not([disabled])');
      if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === a || document.activeElement === hoja)) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    });
    // Deslizar hacia abajo para cerrar (desde la parte alta del panel).
    var y0 = null, dy = 0;
    hoja.addEventListener('touchstart', function (e) {
      if (hoja.scrollTop > 0 || e.touches.length !== 1) { y0 = null; return; }
      y0 = e.touches[0].clientY; dy = 0;
    }, { passive: true });
    hoja.addEventListener('touchmove', function (e) {
      if (y0 === null) return;
      dy = e.touches[0].clientY - y0;
      if (dy > 0) { sheet.classList.add('is-arrastrando'); hoja.style.transform = 'translateY(' + dy + 'px)'; }
    }, { passive: true });
    hoja.addEventListener('touchend', function () {
      if (y0 === null) return;
      sheet.classList.remove('is-arrastrando'); hoja.style.transform = '';
      if (dy > 80) cerrarHoja();
      y0 = null; dy = 0;
    });
  }
  var tFin;
  function abrirHoja() {
    crearHoja();
    clearTimeout(tFin);
    pintar();
    sheet.hidden = false;
    document.body.classList.add('nibec-hc-overflow-hidden');
    btn.setAttribute('aria-controls', 'nibec-hc-hoja');
    btn.setAttribute('aria-expanded', 'true');
    void sheet.offsetWidth;
    sheet.classList.add('is-abierto');
    try { hoja.focus({ preventScroll: true }); } catch (e) { hoja.focus(); }
    medirAbrir('toque');
  }
  function cerrarHoja() {
    if (!sheet || !sheet.classList.contains('is-abierto')) return;
    sheet.classList.remove('is-abierto'); contado = false;
    document.body.classList.remove('nibec-hc-overflow-hidden');
    btn.setAttribute('aria-expanded', 'false');
    var fin = function () { if (!sheet.classList.contains('is-abierto')) sheet.hidden = true; };
    if (mqReducir.matches) fin(); else tFin = setTimeout(fin, 240);
    try { btn.focus({ preventScroll: true }); } catch (e) {}
  }

  // Formulario desde el panel de escritorio (el del panel inferior se mide arriba).
  panel.addEventListener('click', function (e) {
    var f = e.target.closest && e.target.closest('[data-hc-form]');
    if (f) track('nibec_hdr_cotizar_formulario', { items: lista().length });
  });

  // Al cruzar los 990 px (girar la tablet, cambiar el ancho) se cierra lo que esté abierto.
  var alCambiar = function () { cerrar(); cerrarHoja(); };
  if (mqEsc.addEventListener) mqEsc.addEventListener('change', alCambiar); else if (mqEsc.addListener) mqEsc.addListener(alCambiar);

  document.addEventListener('nibec:lista', pintar);
  window.addEventListener('storage', pintar);
  // nibec-cotizacion.js (que expone NibecCotizacion) se carga después: se pinta de nuevo cuando ya está.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pintar); else pintar();
  pintar();
})();
